import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ICareersFilterProps } from '../CareerCardGroup';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ICareersDashboardHeadingFilterProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Description Text
	 */
	description?: string;
	allCareers?: ILink;
}

const CareersDashboardHeadingFilter: React.FC<ICareersDashboardHeadingFilterProps> =
	({ className, classNames = [], heading, description, allCareers }) => (
		<div
			className={
				className ||
				cn(
					'calian-careers-dashboard-heading-filter pt-3 pb-4 pt-lg-6 pb-lg-5 px-3 px-sm-3 px-lg-5',
					...classNames,
				)
			}
		>
			<div className="calian-careers-dashboard-heading-filter__top d-flex flex-column flex-md-row justify-content-between align-items-start align-items-sm-center mb-4">
				{heading && (
					<h2 className="calian-careers-dashboard-heading-filter__heading fs-22px fs-sm-1 mb-2 mb-sm-4 mb-md-0">
						{heading}
					</h2>
				)}
				{description && (
					<p className="calian-careers-dashboard-heading-filter__mobile-description d-sm-none fs-7 mb-2 pb-1">
						{description}
					</p>
				)}
				{allCareers && (
					<Button
						{...allCareers}
						classNames={['d-block', 'd-sm-none']}
					/>
				)}
			</div>
			<div className="calian-careers-dashboard-heading-filter__bottom d-none d-sm-block">
				{description && (
					<p className="calian-careers-dashboard-heading-filter__description fs-5 lh-base mb-0">
						{description}
					</p>
				)}
				{allCareers && <Button {...allCareers} classNames={['mt-3']} />}
			</div>
		</div>
	);

export default CareersDashboardHeadingFilter;
